export default __webpack_public_path__ + "static/media/rate.e110d4b1.svg";